<template>
  <b-container fluid>
    <api-list :type="type" />
  </b-container>
</template>
<script>
  import ApiList from '@/components/Engine/ApiList'

  export default {
    name: 'ListingPage',
    components: {
      ApiList
    },
    props: {
      type: {
        type: String,
        default: 'users'
      }
    }
  }
</script>
